module.exports = __webpack_public_path__ + "assets/img/government2-bottom.279e7c0c.png";